import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { changeCursorTo, CursorTypes } from '../../utils/changeCursor';
import {
  hideImportBatchBeginningBalancesModal,
  importBatchBeginningBalancesFile,
} from './store/actions';
import Modal from '../../shared/modals/modal.component';
import { isUploadingBeginningBalancesSelector } from './store/selectors';
import { renderImportInstructions } from './importFileFormatRules';
import { requiredWhenPresent } from '../../shared/propTypes';

class ImportBatchBeginningBalancesModal extends PureComponent {
  static propTypes = {
    hideImportBatchBeginningBalancesModal: PropTypes.func.isRequired,
    importBatchBeginningBalancesFile: PropTypes.func.isRequired,
    connection: requiredWhenPresent(['isVisible'], PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })),
    isUploadingBeginningBalances: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool,
  };

  componentDidUpdate(prevProps) {
    const isUploadingBeginningBalancesChanged = (
      prevProps.isUploadingBeginningBalances !== this.props.isUploadingBeginningBalances
    );

    if (isUploadingBeginningBalancesChanged && prevProps.isUploadingBeginningBalances) {
      changeCursorTo(CursorTypes.DEFAULT);
      this.props.hideImportBatchBeginningBalancesModal();
    }
  }

  importBatchBeginningBalancesFile = event => {
    event.persist();
    const file = event.target.files[0];

    if (!file) {
      return;
    }

    const { connection } = this.props;

    this.props.importBatchBeginningBalancesFile({
      file,
      connectionName: connection.value,
    });

    event.target.value = '';
  };

  render() {
    const {
      connection,
      hideImportBatchBeginningBalancesModal,
      isUploadingBeginningBalances,
      isVisible,
    } = this.props;

    return (
      <Modal
        className="import-beginning-balances-modal"
        title="Import Batch Beginning Balances"
        closeAction={hideImportBatchBeginningBalancesModal}
        dismissText="Cancel"
        dismissAction={hideImportBatchBeginningBalancesModal}
        submitText="Select File to Import"
        submitAction={this.importBatchBeginningBalancesFile}
        isVisible={isVisible}
        isSubmitting={isUploadingBeginningBalances}
        withUpload
      >
        {
          connection
            ? (
              <div>
                Connection: {connection.label}<br /><br />
                Import file must have the following Excel format:<br />
                {renderImportInstructions()}
                Warning: All current Beginning Balance rows will be removed and replaced with the imported values.
              </div>
            )
            : null
        }
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    isUploadingBeginningBalances: isUploadingBeginningBalancesSelector(state),
  };
}

export default connect(
  mapStateToProps,
  {
    hideImportBatchBeginningBalancesModal,
    importBatchBeginningBalancesFile,
  }
)(ImportBatchBeginningBalancesModal);
